import { PackageDepartmentEnum, PackageRecurrenceEnum } from "../../__generated__/graphql";
import type { PackageDetailData } from "./types";

export const TERMS_AND_CONDITIONS_URL = "https://www.luce.sg/legal/terms-and-conditions";

const SHORT_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function getFrequencyLabel(repeatEvery: PackageRecurrenceEnum, repeatEveryTimes: number) {
  switch (repeatEvery) {
    case PackageRecurrenceEnum.Week:
      return "Weekly";
    case PackageRecurrenceEnum.Fortnight:
      return "Fortnightly";
    case PackageRecurrenceEnum.Month:
      return "Monthly";
    case PackageRecurrenceEnum.Year:
      if (repeatEveryTimes === 3) return "Tri-Yearly";
      if (repeatEveryTimes === 4) return "Quarterly";
      return "Yearly";
    default:
      return "Ad Hoc";
  }
}

export function getBillingTypeLabel({
  department,
  repeatEvery,
}: Pick<PackageDetailData, "department" | "repeatEvery">) {
  return department === PackageDepartmentEnum.Aircon && repeatEvery !== PackageRecurrenceEnum.AdHoc
    ? "Prepaid"
    : "Postpaid";
}

function formatTaskTime(time: string) {
  return time.split(":").join(".");
}

export function formatSchedules(tasks: PackageDetailData["tasks"]) {
  if (!tasks?.length) return "Not Set";

  const schedules = [...tasks]
    .sort((a, b) => a.day - b.day || a.startTime.localeCompare(b.startTime))
    .map(
      ({ day, startTime, endTime }) =>
        `${SHORT_DAYS[day]}, ${formatTaskTime(startTime)} - ${formatTaskTime(endTime)}`,
    );

  return [...new Set(schedules)].join("; ");
}

export function isUpcomingPlan(startDate: string) {
  return new Date(startDate).getTime() > Date.now();
}
